module.exports = __webpack_public_path__ + "01ed4f6b43c9f971d152a28de2ee9002.pdf";